document.addEventListener('DOMContentLoaded', async () => {
  const form = document.getElementById('occasion-form');
  const receiverInput = document.getElementById('occassion-input');
  const dateInput = document.getElementById('occasionDate')
  const listContainer = document.getElementById('occasion-list');
  const openingDropdownMessage = document.getElementById('openingLine')
  const dropdown = document.getElementById('userOccasionsDropdown')
  const cardMessageField = document.getElementById('Notes')

  const SELECTOR = '#userOccasionsDropdown'

  const getOccasions = async (customerId) => {
    return await fetch(`https://cardily-api-12.onrender.com/${customerId}`)
    .then(response => response.json())
    .catch(err => console.error(err))
  }

  let occasions = await getOccasions(customerId)

  const populateDropdown = (occasions) => {
    const select = document.querySelector(SELECTOR);
    if (!select) {
      console.warn(`Dropdown not found: ${SELECTOR}`);
      return;
  }
    // Keep any existing placeholder option, if present.
    select.querySelectorAll('option[data-occasion]').forEach(option => option.remove());

    occasions.forEach(item => {
      const option = document.createElement('option');
      option.value = item.occasion;
      option.textContent = item.occasion;
      select.appendChild(option);
    });

      select.addEventListener('click', e => {
      cardMessageField.value = e.target.value
    })
  }



  if (!form || !receiverInput || !listContainer || !dateInput) {
    populateDropdown(occasions)
    console.error('One or more DOM elements not found!');
    return;
  }


  async function refreshDropdown() {
  try {
    const occasions = await getOccasions(customerId);
    populateDropdown(occasions);
  } catch (error) {
    console.error('Could not populate occasions:', error);
  }
}

  const productInfoContainer = document.querySelector('#ProductInfo-template--22058250305714__main');

  if (productInfoContainer) {
    const observer = new MutationObserver(() => {
      refreshDropdown();
    });

    observer.observe(productInfoContainer, { childList: true, subtree: true });
  }

  refreshDropdown();

  const removeOccasions = async (customerId, removedOccasion) => {
  const response = await fetch(
    `https://cardily-api-12.onrender.com/${customerId}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ occasion: removedOccasion})
    }
  );

  if (!response.ok) {
    throw new Error(`Remove failed: ${response.status}`);
  }
};

  // Function to render the list
  const renderPeople = async () => {
    listContainer.innerHTML = '';
    let occasions = await getOccasions(customerId)
    if(!occasions.length) {
        listContainer.textContent =
          "Sorry, we don't seem to have a list of saved occasions.";
    } else {
      occasions.forEach((person, index) => {
        const div = document.createElement('div');
        const textParagraph = document.createElement('p');
        const dateSpan = document.createElement('span');
        const divider = document.createElement('hr');
        textParagraph.textContent = `${person.occasion}`;
        dateSpan.textContent = `${person.date}`
        div.style.cursor = 'pointer'
    
       
        // Add remove button
        const removeBtn = document.createElement('button');
        removeBtn.textContent = 'remove';
        removeBtn.style.cursor = 'pointer'
         removeBtn.onclick = async (e) => {
          e.preventDefault();

          removeBtn.disabled = true;
          try {
            await removeOccasions(customerId, person.occasion);
            await renderPeople();
          } catch (error) {
            console.error('Could not remove occasion:', error);
            removeBtn.disabled = false;
          }
        };
        div.appendChild(textParagraph);
        div.appendChild(dateSpan);
        div.appendChild(removeBtn);
        div.appendChild(divider)
        listContainer.appendChild(div);
      });
    } 
  }

  // Initial render
  await renderPeople();

  //Post the data to the database
  const postOccassion = (customerId, newOccasion) => {
    fetch(`https://cardily-api-12.onrender.com/occasions/${customerId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify(newOccasion)
    })
    .then(response => response.json())
    .catch(err => console.error(err))
  }

  // Handle form submit
  form.onsubmit = (e) => {
    e.preventDefault();
    const occasion = receiverInput.value.trim();
    const date = dateInput.value.trim().toString()
    const dateString = new Date(date)
    
    if (occasion !== '' & date !== '') {
      postOccassion(customerId, {occasion: occasion, date: (dateString.toString()+ 1).substring(0, dateString.toString().length - 43)})
      setTimeout(() => {
        getOccasions(customerId)
      }, 300);
      setTimeout(() => {
        renderPeople()
      }, 500);
      receiverInput.value = '';
    }
  };
});

    

